import type { UseQueryArgs } from 'urql';

import {
  ENTITY_V2_QUERY,
  type GetEntityDataV2Query,
  type GetEntityDataV2QueryVariables,
} from '@revelio/data-access';

import { useEffectiveFilters } from '../../filters/hooks/useEffectiveFilters';
import { FilterId, type PrimaryFilterId } from '../../filters/types/filters';
import {
  getCompanySummaryFilters,
  getRoleSummaryFilters,
} from '../../filters/utils/get-overview-filters';
import type { DataProviderChildren } from './types';
import { useUrqlQueryWithStatus } from './utils/data-provider-results-utils';

export const EntitySummaryDataProvider = ({
  primaryDimension,
  children,
}: {
  primaryDimension: PrimaryFilterId;
  children: DataProviderChildren<GetEntityDataV2Query | undefined>;
}) => {
  const effectiveFilters = useEffectiveFilters();

  const summaryFilters =
    primaryDimension === FilterId.COMPANY
      ? getCompanySummaryFilters(effectiveFilters)
      : getRoleSummaryFilters(effectiveFilters);

  const queryFilters: UseQueryArgs<
    GetEntityDataV2QueryVariables,
    GetEntityDataV2Query
  > = {
    query: ENTITY_V2_QUERY,
    variables: { req: summaryFilters },
    pause: !summaryFilters,
  };

  const [{ data, status }] = useUrqlQueryWithStatus(queryFilters);

  return children({ data, status });
};
